import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Drawer } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './Contents/styles.module.scss';
import { FileInfoDrawerProps } from './types';

const cx = classNames.bind(styles);

export const FileInfoDrawer: FC<FileInfoDrawerProps> = memo(
  ({ open, onClose, title, children }) => {
    const containerRef = useGlobalContainerRef();

    const drawerTitle = title ? (
      <FileNameSeparatorWithExtension
        containerClassName={cx(styles['file-name-text'])}
      >
        {title}
      </FileNameSeparatorWithExtension>
    ) : (
      ''
    );

    return (
      <Drawer
        visible={open}
        width={456}
        onClose={onClose}
        title={drawerTitle}
        getContainer={containerRef}
        mask
      >
        {children}
      </Drawer>
    );
  }
);
FileInfoDrawer.displayName = 'FileInfoDrawer';
